import React, { forwardRef } from 'react';

import * as classes from './style.module.scss';

const SkipToContent = forwardRef<HTMLAnchorElement>((props, ref) => (
  <a tabIndex={0} className={classes.root} href="#content-top" ref={ref}>
    Skip to main content
  </a>
));

SkipToContent.displayName = 'SkipToContent';

export { SkipToContent };
